/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percent (w/v)`)
};

const es_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcentaje (p/v)`)
};

const de_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozent (w/v)`)
};

const nl_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage (g/v)`)
};

const fr_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourcentage (p/v)`)
};

const it_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentuale (p/v)`)
};

const pt_br2_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentual (p/v)`)
};

const pt_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentagem (m/v)`)
};

const ja_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント (w/v)`)
};

const zh_pctsol_field_percent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比（w/v）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_field_percent = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_field_percent(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_field_percent", locale)
	if (locale === "en") return en_pctsol_field_percent(inputs)
	if (locale === "es") return es_pctsol_field_percent(inputs)
	if (locale === "de") return de_pctsol_field_percent(inputs)
	if (locale === "nl") return nl_pctsol_field_percent(inputs)
	if (locale === "fr") return fr_pctsol_field_percent(inputs)
	if (locale === "it") return it_pctsol_field_percent(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_field_percent(inputs)
	if (locale === "pt") return pt_pctsol_field_percent(inputs)
	if (locale === "ja") return ja_pctsol_field_percent(inputs)
	return zh_pctsol_field_percent(inputs)
};